module.exports = "data:image/gif;base64,R0lGODlhFgAWAKECAN3q+8PZ/////////yH5BAEKAAIALAAAAAAWABYAAAJAlI+pFu0P3wmg2otBm7nbzXgeKFDAiaYqaaouyr6yFnCzG99rHepp7jsBg0NfUXe8JWdLGSsChUyiVN7iis1mCwA7"


//////////////////
// WEBPACK FOOTER
// ./~/rt-sd-comp/~/react-umeditor/dist/images/highlighted.gif
// module id = 2038
// module chunks = 1